import * as React from 'react';

import PersonalInformation from '../../containers/PersonalInformation/PersonalInformation';
import Activity from '../../containers/Activity/Activity';
import Communication from '../Communication/Communication';
import PaimentsInfo from '../../containers/PaymentsInfo/PaymentsInfo';

interface Props {
  activeTab: number;
}

const Tabs = (props: Props) => {

  const activeTab = props.activeTab;

  if (activeTab === 0) {
    return <PersonalInformation />;
  } else if (activeTab === 1) {
    return <Activity />;
  } else if (activeTab === 2) {
    return <Communication />;
  } else if (activeTab === 3) {
    return <PaimentsInfo />;
  }
};

export default Tabs;
